import { Component } from '@theme/component';

class ApcMenuToggle extends Component {
  requiredRefs = ['button'];

  toggle() {
    const { button } = this.refs;
    const target = document.getElementById(button.getAttribute('aria-controls'));
    target?.dispatchEvent(new CustomEvent('apc-menu-toggle:toggle', { detail: { trigger: button } }));
  }
}

if (!customElements.get('apc-menu-toggle')) {
  customElements.define('apc-menu-toggle', ApcMenuToggle);
}
